import { combineReducers } from 'redux';

import { CONVERSATION_TYPES } from 'constants/ChatConstants';
import { FETCH_CONVERSATIONS } from 'modules/chat/actionTypes';
import error from 'modules/global/reducers/generic.error';
import hasMore from 'modules/global/reducers/generic.hasMore';
import loading from 'modules/global/reducers/generic.loading';
import page from 'modules/global/reducers/generic.page';

import ids from './ids';

const matcher = ({ meta }) => meta.type === CONVERSATION_TYPES.INTERNAL;

/**
 * @typedef {{
 *  ids: string[],
 *  page: import("modules/global/generic.types").Page,
 *  error: string | null,
 *  hasMore: boolean,
 *  isLoading: boolean
 * }} ChatUiInternalReducer
 */

export default combineReducers({
  ids,
  page: page(FETCH_CONVERSATIONS, { global: { matcher } }),
  error: error(FETCH_CONVERSATIONS, { global: { matcher } }),
  isLoading: loading(FETCH_CONVERSATIONS, { global: { matcher } }),
  hasMore: hasMore(FETCH_CONVERSATIONS, { global: { matcher } }),
});
